<tan-loader [loading]="(quoteLoading$ | async)" [loadingText]="'<p>Retrieving Quote</p>'">
</tan-loader>

<div class="row justify-content-center" *ngIf="(quoteError$ | async)">
  <div class="col-sm-12 d-flex justify-content-center">
    <tan-alert-message [errorType]="'error'" [message]="'Could not retrieve Quote'"></tan-alert-message>
  </div>
</div>

<div class="row mt-3" *ngIf="!(quoteLoading$ | async) && !(quoteError$ | async) && quote">
  <div class="col-sm-12">
    <ng-container *ngIf="quoteType == 'rental'">
      <app-view-rental [data]="quote"></app-view-rental>
    </ng-container>
    <ng-container *ngIf="quoteType == 'purchase'">
      <app-view-purchase [data]="quote"></app-view-purchase>
    </ng-container>
  </div>
</div>